import { h } from "preact";

import Button from "../../theme/typography";

export function resendconfmail(app) {
    //

    const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
    };

    fetch("/api/7e84cbc3b44a4a879c1593b31b1a89b5", requestOptions)
        .then((response) => {
            return response.json();
        })
        .then((res) => {
            switch (res.res) {
                case "ok":
                    app.refSnack.current.handleChangeState({ o: true, m: "Le mail a été renvoyé" });
                    break;

                case "err":
                    break;
                default:
                    break;
            }
        });
}

export function resendconfmail2(app, uid) {

    //
    const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
    };

    fetch("/api/aa25621752d64a6c8b9a9f8ddb7ef981/" + uid, requestOptions)
        .then((response) => {
            return response.json();
        })
        .then((res) => {
            switch (res.res) {
                case "ok":
                    app.refSnack.current.handleChangeState({ o: true, m: "Le mail a été renvoyé" });
                    break;

                case "err":
                    break;
                default:
                    break;
            }
        });
}

export function resendconfphone(app) {
    //
    const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
    };

    fetch("/api/0c23d49d14d74bbf9f85aa43629030d9", requestOptions)
        .then((response) => {
            return response.json();
        })
        .then((res) => {
            switch (res.res) {
                case "ok":
                    app.refSnack.current.handleChangeState({ o: true, m: "Le code a été renvoyé" });
                    break;

                case "err":

                    break;
                default:
                    break;
            }
        });
};

export function plain_fetch(url, cb) {

    //
    const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
    };

    fetch(url, requestOptions)
        .then((response) => {
            return response.json();
        })
        .then((res) => {
            switch (res.res) {
                case "ok":

                    if (cb !== undefined) {
                        cb({ ...res.pld });
                    }

                    break;

                case "err":
                    break;
                default:
                    break;
            }
        });
}


export function deal_dashboard_guidelines(deal, app) {

    if (deal === undefined) return false;

    if (deal && deal.md.length > 0) {
        var actions = (
            <Button
                variant="contained"
                onClick={() => {
                    window.location.href = "/user";
                }}
            >
                Compléter mon profil
            </Button>
        );

        var lbl00 = <div>Attention, il vous reste des actions à effectuer{deal.md.map((md, idx) => { return <div>{md.label}</div> })}</div>;
        //var lbl00 = (<div><Typography variant="h5" style="margin-bottom: 10px;">Attention, il vous reste des actions à effectuer sur le{deal.md.length > 1 ? "s" : ""} dossier{deal.md.length > 1 ? "s" : ""} suivant{deal.md.length > 1 ? "s" : ""}</Typography></div>)
        app.refHeader.current.handleChangeState({
            guidelines: {
                message: lbl00,
                //  actions: actions,

            }
        })
    }

}

export function dedupArrayOfObjects(arr) {
    var actions0 = arr.reduce((acc, u) => {

        if (u.action !== null) {
            return acc.concat(u.action)

        }

    }, [])

    return actions0.filter((c, index) => {
        return index === actions0.findIndex(function (p, index) {
            if (p.u == c.u)
                return true;
        });
        ;
    });
}

export function addFromToURL(url) {
    let rurl = url + (url.indexOf("?") > -1 ? "" : "?") + (url.indexOf("&") > -1 ? "&" : "") + "from=" + window.location.pathname;
    console.log("addFromToURL", rurl)
    return rurl;
}
